import {Box, Show, Space, Text, VStack} from 'platform/foundation';

import {trim, uniq} from 'ramda';

import {SellerResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

interface SellerProps {
  seller: SellerResponseBody;
}

export function Seller(props: SellerProps) {
  const phoneNumbers = uniq(props.seller.phone?.split(',').map(trim) ?? []);

  return (
    <Box backgroundColor="palettes.neutral.20.100" borderRadius="medium" padding={4}>
      <Text size="xSmall" color="secondary">
        {i18n.t('entity.sourcing.vehiclePreview.labels.dealer')}
      </Text>
      <Space vertical={2} />
      <Text alternative>{props.seller.name}</Text>
      <Space vertical={2} />
      <Text size="small" color="secondary">
        {props.seller.address}
        <br />
        {props.seller.city}
      </Text>
      <Space vertical={6} />
      <VStack>
        {phoneNumbers.map((phone) => (
          <Text key={phone} size="small" alternative>
            {phone}
          </Text>
        ))}
      </VStack>
      <Show when={props.seller.email}>
        <Space vertical={2} />
        <Text size="small">{props.seller.email}</Text>
      </Show>
    </Box>
  );
}
